export default {
    breadcrumbs: {
        home: 'Home',
        manage_account: 'Manage account',
        preview: 'Preview account',
        user_profile: 'User profile',
    },
    offer_tabs: {
        active: 'Active ({number})',
        renewal: 'For reneewal ({number})',
        expired: 'Expired ({number})',
    },
    tabs: {
        offers: 'Services',
    },
    modal: {
        complete_profile: 'To preview account fill first and last name!',
        delete_profile: 'Are you sure you want to delete the profile?',
    },
    delete_profile_button: 'Delete account',
}
